<template>
  <div class="app-link-icon">
    <!-- external link -->
    <AppLink
      v-if="linkItem.external"
      :href="linkItem.to ? linkItem.to : false"
      :text="showLabel ? linkItem.label : ''"
      :disabled="isDisabled"
      :class="isDisabled && 'disabled'"
    >
      <AppIcon :icon="linkItem.icon" />
    </AppLink>
    <!-- app link -->
    <AppRouterLink
      v-else
      :text="showLabel ? linkItem.label : ''"
      :to="linkItem.to"
      :disabled="isDisabled"
      :class="isDisabled && 'disabled'"
    >
      <AppIcon :icon="linkItem.icon" />
    </AppRouterLink>
    <slot />
  </div>
</template>

<script>
// Utilities
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppLink from 'Ui/AppLink'
import AppRouterLink from 'Ui/AppRouterLink'

export default {
  name: 'AppLinkIcon',

  components: {
    AppIcon,
    AppLink,
    AppRouterLink,
  },

  mixins: [MobileBreakpointControl],

  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },

    linkItem: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isDisabled() {
      return this.linkItem.disabled || !this.linkItem.to
    },
  },
}
</script>

<style scoped>
.app-link-icon {
  overflow: hidden;
}

.app-link-icon .app-link {
  display: flex;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: var(--c-primary);
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  text-decoration: none;
  overflow: hidden;
  cursor: pointer;
  transition: 0.4s all;
}

.app-link-icon .app-link.disabled {
  color: var(--c-gray-400);
  cursor: not-allowed;
}

.app-link-icon .app-link--active,
.app-link-icon .app-link:not(.disabled):hover {
  background-color: var(--c-secondary-400);
}

.app-link-icon .app-icon {
  font-size: 18px;
  color: var(--c-secondary);
  margin-right: 0;
}

.app-link-icon .app-link.disabled .app-icon {
  color: var(--c-gray-400);
}

.app-link-icon .app-link >>> .app-link__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 10px;
  user-select: none;
}

@media (max-width: 680px) {
  .app-link-icon .app-link {
    justify-content: center;
    border-top: 2px solid transparent;
    border-radius: 0;
    transition: none;
  }

  .diy-sidebar__link--active,
  .diy-sidebar__link:not(.disabled):hover {
    background-color: transparent;
  }

  .diy-sidebar__link--active {
    border-color: var(--c-secondary-800);
  }

  .diy-sidebar__link--active .diy-sidebar__link-icon {
    color: var(--c-secondary-800);
  }
}
</style>
